export type WalletPresentationState = 'resolving' | 'connected' | 'disconnected'

export interface WalletPresentationSignals {
  isAuthenticated: boolean
  isTonConnectRestoreSettled: boolean
  isBackendAuthRestoring: boolean
}

export const projectWalletPresentationState = ({
  isAuthenticated,
  isTonConnectRestoreSettled,
  isBackendAuthRestoring,
}: WalletPresentationSignals): WalletPresentationState => {
  if (isAuthenticated) return 'connected'
  if (!isTonConnectRestoreSettled || isBackendAuthRestoring) return 'resolving'
  return 'disconnected'
}
